var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navbar-container"},[_c('img',{attrs:{"src":require('../assets/EENLogo.png')}}),(_setup.version)?_c('span',{staticClass:"navbar-container__version"},[_vm._v("v"+_vm._s(_setup.version))]):_vm._e(),_c('div',{staticClass:"navbar-container__horizontal-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }